import { Options } from 'ky';
import ky from 'ky/umd';
import { KyOptions } from '.';
import kyErrorLoggerHook from './kyErrorLoggerHook';
import kyUnauthorizedHook from './kyUnauthorizedHook';

/**
 * Headers that will be added to every api request
 */
export const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  //'X-Requested-With': 'ky',  // FIXME: breaks WP requests
  Origin: process.env.BASE_URL,
};

export const defaultKyOptions: KyOptions = {
  timeout: 20000,
  retry: 3,
  hooks: {
    afterResponse: [kyErrorLoggerHook, kyUnauthorizedHook],
  },
};

/**
 * Ky instance for querying the main Give Inkind api
 */
export const api = ky.create({
  headers: {
    ...defaultHeaders,
  },
  ...(defaultKyOptions as Options),
  prefixUrl: process.env.DOTNET_API_URL,
  throwHttpErrors: false, // we will handle the errors manually and throw custom http errors
});

const originalApiPost = api.post;
api.post = (...args) => originalApiPost(args[0], { timeout: 60000, ...args[1] });

/**
 * Ky instance for querying the Give Inkind wordpress api (custom plugins)
 */
export const wpCustomApi = ky.create({
  headers: defaultHeaders,
  ...(defaultKyOptions as Options),
  prefixUrl: process.env.WP_CUSTOM_API_URL,
});

/**
 * Ky instance for querying the Give Inkind wordpress api
 */
export const wpApi = ky.create({
  headers: defaultHeaders,
  ...(defaultKyOptions as Options),
  prefixUrl: process.env.WP_API_URL,
});

/**
 * Ky instance for querying the Give Inkind acf v3 wordpress api
 */
export const wpAcfV3Api = ky.create({
  headers: defaultHeaders,
  ...(defaultKyOptions as Options),
  prefixUrl: process.env.WP_ACF_V3_API_URL,
});

/**
 * Ky instance for querying the Give Inkind WooCommerce api
 */
export const wcApi = ky.create({
  headers: defaultHeaders,
  ...(defaultKyOptions as Options),
  prefixUrl: process.env.WC_API_URL,
});

/**
 * Ky instance for querying the Vimeo endpoint
 */
export const vimeoApi = ky.create({
  headers: {
    Accept: 'application/json',
    'sec-ch-ua-mobile': '?0',
    'Sec-Fetch-Dest': 'empty',
    'Sec-Fetch-Mode': 'cors',
    'Sec-Fetch-Site': 'cross-site',
  },
  ...(defaultKyOptions as Options),
  prefixUrl: 'https://vimeo.com/api',
});
